<template>
  <div>
    <a-card title="Company Financials" style="margin:20px 0px">
      <div class="text-right">
        <a-button type="primary" style="margin-right:10px" @click="_download">
          下载财报
        </a-button>
        <a-button type="primary" @click="_archived">转存财报</a-button>
      </div>
      <h4>Balance Sheet：</h4>
      <p>Currency：RMB</p>
      <p>Unit： 10,000</p>
      <a-table
        :columns="FinancialsColumns"
        :data-source="FinancialsData"
        size="middle"
      />
    </a-card>
    <a-card title="Income" style="margin:20px 0px">
      <h4>Statement：</h4>
      <p>Currency：RMB</p>
      <p>Unit： 10,000</p>
      <a-table
        :columns="IncomeColumns"
        :data-source="IncomeData"
        size="middle"
      />
    </a-card>
  </div>
</template>

<script>
const formatAmount = num => {
  return numeral(num).format('0,0.00')
}
import numeral from 'numeral'
import { getGoogolRepert, download, archived } from '../../api'
import { mapGetters } from 'vuex'
const FinancialsColumns = [
  {
    title: '年份/科目(Year/Items)',
    dataIndex: 'year',
  },
  {
    title: '资产总计(Total Assets)',
    dataIndex: 'assGro',
  },
  {
    title: '负债总计(Total Liabilities)',
    dataIndex: 'liaGro',
  },
  {
    title: '所有者权益(Owners’ Equity)',
    dataIndex: 'totEqu',
  },
]
const IncomeColumns = [
  {
    title: '年份/科目(Year/Items)',
    dataIndex: 'year',
  },
  {
    title: '营业总收入(Total Revenue)',
    dataIndex: 'vendInc',
  },
  {
    title: '主营业务收入(Revenues from Main Operations)',
    dataIndex: 'maiBusInc',
  },
  {
    title: '利润总额(Total Profits)',
    dataIndex: 'proGro',
  },
  {
    title: '纳税总额(Total Tax)',
    dataIndex: 'ratGro',
  },
  {
    title: '净利润(Net Profits)',
    dataIndex: 'netInc',
  },
]
export default {
  data() {
    //这里存放数据
    return {
      FinancialsColumns,
      FinancialsData: [],
      IncomeColumns,
      formatAmount,
      IncomeData: [],
      format: [
        'assGro',
        'liaGro',
        'totEqu',
        'vendInc',
        'maiBusInc',
        'proGro',
        'ratGro',
        'netInc',
      ],
    }
  },
  components: {},

  //方法集合
  methods: {
    async _archived() {
      const { id } = this.bureauReportBasicInfo
      await archived(id)
      this.$message.success('转存财报成功')
    },
    async _download() {
      const { id } = this.bureauReportBasicInfo
      await download(id)
    },
    async _getGoogolRepert() {
      const { id } = this.bureauReportBasicInfo
      const { data } = await getGoogolRepert(id)
      data.bigList.forEach(item => {
        this.format.forEach(key => {
          item[key] = this.formatAmount(item[key])
        })
      })
      this.FinancialsData = data.bigList
      this.IncomeData = data.bigList
    },
  },
  computed: {
    ...mapGetters('app', ['bureauReportBasicInfo']),
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this._getGoogolRepert()
  },
}
</script>
<style scoped less>
p {
  margin: 5px 0;
}
.text-right {
  text-align: right;
  margin-bottom: 20px;
}
</style>
